import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from '@/components/button';
import { StyleProp, ViewStyle } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  onPress: () => void;
  trackingData: TrackingData;
}

export const CreditMemoPDFButton: React.FC<Props> = ({
  containerStyle,
  onPress,
  trackingData,
}) => {
  return (
    <Button
      containerStyle={containerStyle}
      onPress={onPress}
      trackingData={trackingData}
      type="secondary"
    >
      {i18n.t('view_credit_memo_pdf')}
    </Button>
  );
};
